<template>
    <div class="divide-y divide-border">
        <slot />
    </div>
</template>
